import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { detectCountry } from '@/shared/constants/countries'

interface CountryState {
  country: string
  setCountry: (country: string, persist?: boolean) => void
}

function getInitialCountry(): string {
  if (typeof window === 'undefined') {
    return detectCountry()
  }
  return localStorage.getItem('preferredCountry') || detectCountry()
}

export const useCountryStore = create<CountryState>()(
  devtools(
    (set) => ({
      country: getInitialCountry(),
      setCountry: (country, persist = true) => {
        if (persist) {
          localStorage.setItem('preferredCountry', country)
        }
        set({ country })
      },
    }),
    { name: 'country-store' }
  )
)
